import { ErrorsResponse } from './@types/responses/common/ErrorsResponse'
import { LOCAL_STORAGE_CONSTANTS } from './constants/localstorage.contstants'
import router from './router'
import { MiscellaneousService } from './services/miscellaneous.service'

export default function authenticatedFetch(input: Request | string, miscellaneousService: MiscellaneousService, requestInit?: RequestInit): Promise<Response> {
  if (!requestInit)
    requestInit = {} as RequestInit
  
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Authorization', `Bearer ${localStorage.getItem(LOCAL_STORAGE_CONSTANTS.accessToken)}`)

  requestInit.headers = headers

  return fetch(input, requestInit).then(async response => {
    if (response.ok)
      return response

    switch (response.status) {
      case 400: {
        const errorsResponse = await response.json()
        return Promise.reject(new ErrorsResponse(errorsResponse.errors))
      }
      case 401: {
        return miscellaneousService.refreshAccessToken(router.currentRoute.value.fullPath).then(() => {
          if (!requestInit)
            requestInit = {} as RequestInit
          
          const updatedHeaders = new Headers()
          updatedHeaders.append('Content-Type', 'application/json')
          updatedHeaders.append('Authorization', `Bearer ${localStorage.getItem(LOCAL_STORAGE_CONSTANTS.accessToken)}`)

          requestInit.headers = updatedHeaders
          
          return authenticatedFetch(input, miscellaneousService, requestInit)
        })
      }
      case 403: {
        if (window.location.href !== '') {
          localStorage.setItem(LOCAL_STORAGE_CONSTANTS.accessToken, '')
          localStorage.setItem(LOCAL_STORAGE_CONSTANTS.isEmployee, 'false')
          localStorage.setItem(LOCAL_STORAGE_CONSTANTS.refreshToken, '')
          window.dispatchEvent(new CustomEvent(LOCAL_STORAGE_CONSTANTS.eventName))
          window.location.href = `/?returnUrl=${encodeURIComponent(router.currentRoute.value.fullPath)}`
        }

        const errorsResponse = await response.json()
        return Promise.reject(new ErrorsResponse(errorsResponse.errors))
      }
      case 404: {
        window.location.href = '/not-found'

        const errorsResponse = await response.json()
        return Promise.reject(new ErrorsResponse(errorsResponse.errors))
      }
      case 409: {
        const errorsResponse = await response.json()
        return Promise.reject(new ErrorsResponse(errorsResponse.errors))
      }
      case 500: {
        const errorsResponse = await response.json()
        return Promise.reject(new ErrorsResponse(errorsResponse.errors))
      }
      default: {
        return Promise.reject()
      }
    }
  })
}
